import { useCallback, useEffect, useRef } from 'react'
import useClevertapForSrp from '../../analytics/clevertap/srp'
import useGetSearchQueryURL from '../getSearchQueryURL'
import useUpdateSearchResultCache from '../updateSearchResultCache'
import useSearchResults from '../useSearchResults'

export const useInitialFilterHandler = () => {
    const { applyInitialStopsFilter } = useGetSearchQueryURL()
    const { selectedJourneyLeg, srpResultsLoading, srpResultsError, isRTSplitView } = useSearchResults()
    const updateCache = useUpdateSearchResultCache()
    const { triggerSrpEvent } = useClevertapForSrp()

    const applyInitialFilter = useCallback(() => {
        updateCache(currentData => {
            // Split view shows both legs at once, so seed the nonstop filter on
            // both. Solution/OW seeds only the active leg.
            const legs = isRTSplitView ? [0, 1] : [selectedJourneyLeg]
            legs.forEach(leg => {
                if (currentData?.filterData?.NewStops?.[leg]) {
                    currentData.filterData.NewStops[leg].selectedValues = [0]
                }
            })
            return currentData as NonNullable<typeof currentData>
        })
    }, [updateCache, selectedJourneyLeg, isRTSplitView])

    const shouldApplyInitialFilter = applyInitialStopsFilter && applyInitialStopsFilter !== null && applyInitialStopsFilter !== undefined

    const isBothLegInitialFilterApplied = useRef(false)
    useEffect(() => {
        if (
            shouldApplyInitialFilter &&
            !srpResultsLoading &&
            !srpResultsError &&
            !isBothLegInitialFilterApplied.current
        ) {
            applyInitialFilter()

            // Split applies both legs in one pass; solution view latches once the
            // user reaches the return leg.
            if (isRTSplitView || selectedJourneyLeg === 1) {
                isBothLegInitialFilterApplied.current = true
            }
        }
    }, [shouldApplyInitialFilter, srpResultsLoading, srpResultsError, selectedJourneyLeg, isRTSplitView])


    useEffect(() => {
        if (shouldApplyInitialFilter) {
            triggerSrpEvent('Air_UI_Action', {
                action_name: 'searched_with_non_stop_filter',
                action_type: 'BUTTON',
                action_value: applyInitialStopsFilter
            })
        }

    }, [shouldApplyInitialFilter, applyInitialStopsFilter])

}
